import { UploadDetailsPopUpProps } from "./types";
import { CircularProgress, LinearProgress, Typography } from "@mui/material";
import { Box, ButtonBase } from "@mui/material";
import { styles } from "./styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useCallback, useEffect, useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const FileUploadStatusCard: React.FC<UploadDetailsPopUpProps> = ({
  uploadingFilesDetailsList,
  setIsUploading,
  uploadingCardsStatusList,
  setUploadingCardsStatusList,
  isProcessing,
  folderUploadInfo,
}) => {
  const [isDrawerMinimize, setIsDrawerMinimize] = useState<boolean>(false);

  const drawerStyle = {
    transition: "max-height 0.5s ease",
    maxHeight: isDrawerMinimize ? (isProcessing ? "100px" : "50px") : "400px",
    overflow: "hidden",
  };

  const handleCloseUploadingCard = useCallback(
    (index: number) => {
      setUploadingCardsStatusList((prevList) => {
        const updatedList = prevList.map((file, i) =>
          i === index ? { ...file, isCardClosed: true } : file
        );

        return updatedList;
      });
    },
    [setUploadingCardsStatusList]
  );

  useEffect(() => {
    const remainingFiles = uploadingCardsStatusList.filter(
      (file) => !file.isCardClosed
    );
    if (remainingFiles.length === 0 && !folderUploadInfo) {
      setIsUploading(false);
    }
  }, [uploadingCardsStatusList, setIsUploading, folderUploadInfo]);

  return (
    <>
      <Box
        sx={{ ...styles.uploadingFilesDetailsListContainer, ...drawerStyle }}
      >
        <Box sx={styles.topBar}>
          {folderUploadInfo ? (
            <Typography>Uploading ...</Typography>
          ) : (
            <Typography variant="h6" sx={styles.uploadingContainer}>
              Uploading{" "}
              {
                uploadingCardsStatusList.filter((file) => !file.isCardClosed)
                  .length
              }{" "}
              items
            </Typography>
          )}
          <Box>
            <ButtonBase
              onClick={() => setIsDrawerMinimize(!isDrawerMinimize)}
              sx={styles.buttonBase}
            >
              {isDrawerMinimize ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </ButtonBase>
            {!isProcessing && (
              <ButtonBase
                onClick={() => setIsUploading(false)}
                sx={styles.buttonBase}
              >
                <CloseIcon />
              </ButtonBase>
            )}
          </Box>
        </Box>
        {isProcessing && (
          <Box sx={{ marginLeft: "10px" }}>
            <Typography sx={{ marginBottom: "5px" }}>
              In progress please wait...
            </Typography>
            <LinearProgress />
          </Box>
        )}
        {!isDrawerMinimize && !isProcessing && <Box sx={styles.boxStyle}></Box>}
        {folderUploadInfo && (
          <Box>
            <Typography sx={{ color: "white", marginLeft: "10px" }}>{`${
              folderUploadInfo?.uploadedFiles ?? 0
            } / ${
              folderUploadInfo?.totalFiles ?? 0
            } files uploaded`}</Typography>
          </Box>
        )}
        <Box sx={styles.scrollBox}>
          {uploadingFilesDetailsList.map((file: any, index: number) => {
            return (
              <Box
                sx={{
                  display:
                    file.isCardOpen &&
                    uploadingCardsStatusList[index] &&
                    !uploadingCardsStatusList[index].isCardClosed
                      ? "block"
                      : "none",
                }}
                key={index}
              >
                <Box sx={styles.popUpContainer}>
                  <Box sx={styles.progressWrapper}>
                    <Box sx={styles.infoContainer}>
                      <Typography sx={styles.fileNameText} variant="h6">
                        {file.name}
                      </Typography>
                      <Typography variant="h6" sx={styles.progressText}>
                        {file.uploadProgress}%
                      </Typography>
                    </Box>
                    <Box sx={styles.progressContainer}>
                      {file.uploadProgress === 100 ? (
                        <CheckCircleIcon />
                      ) : (
                        <CircularProgress sx={styles.circularProgress} />
                      )}
                    </Box>
                    <Box sx={styles.progressContainer}>
                      <ButtonBase>
                        <CloseIcon
                          onClick={() => handleCloseUploadingCard(index)}
                        />
                      </ButtonBase>
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};
